"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRequestEndpoint = void 0;
function getRequestEndpoint(operation) {
    const context = operation.getContext();
    if (context.locationId === 'type=peering' || context.locationId === 'peering') {
        if (process.env.NODE_ENV === 'development') {
            console.warn("Apollo GraphQL requests to the peering link server should use context { linkServer: 'peering' }! " +
                'Sending the link server specification as locationId is deprecated since 2020-01-17 and will be removed in a future release.', operation.operationName);
        }
        return { type: 'LINK_SERVER', server: { type: 'peering' } };
    }
    if (context.linkServer === 'peering') {
        return { type: 'LINK_SERVER', server: { type: 'peering' } };
    }
    if (context.linkServer && context.locationId) {
        if (process.env.NODE_ENV === 'development') {
            console.warn('Targeting LinkServer specific for location ID. This should be fixed in backend.', operation.operationName);
        }
        return {
            type: 'LINK_SERVER',
            server: { type: 'locationLinkServer', locationId: context.locationId },
        };
    }
    if (context.linkServer) {
        return { type: 'LINK_SERVER' };
    }
    if (context.locationId) {
        return { type: 'GATEWAY', locationId: context.locationId };
    }
    if (operation.variables.locationId) {
        if (process.env.NODE_ENV === 'development') {
            console.warn('Using locationId variable from query to determine GraphQL request endpoint. ' +
                'This is deprecated since 2020-01-17 and will not be allowed in the future.', 'This error happened for the operation ', operation.operationName);
        }
        return { type: 'GATEWAY', locationId: operation.variables.locationId };
    }
    throw new Error(`Could not determine GraphQL request endpoint for operation with context \`${JSON.stringify(context)}\` and variables \`${JSON.stringify(operation.variables)}\`. Please specify locationId in the context of the request.`);
}
exports.getRequestEndpoint = getRequestEndpoint;
//# sourceMappingURL=endpoint.js.map